import { createRoutine } from "../utils/routine.utils";
export var getUpdateAction = function (params) {
    var entityName = params.entityName;
    return createRoutine("".concat(entityName, "_UPDATE").toUpperCase());
};
